import React, { useCallback, useEffect, useState } from 'react';

import { Button, Container, Link, Typography } from '@material-ui/core';
import { Link as RouterLink, useHistory } from 'react-router-dom';

import { useRedirectResultStyles } from './styles';
import useBlocRefHook from '../../utils/useBlocRef.hook';

export default () => {
  const classes = useRedirectResultStyles();
  const history = useHistory();
  const blocRef = useBlocRefHook('paymentBloc');
  const [uploadedFiles, setUploadedFiles] = useState(null);

  const onUpload = useCallback(
    async (files) => {
      const result = await blocRef.current.onUpload(files);
      if (result) {
        history.push('/patient-dashboard');
      }
    },
    [blocRef, history]
  );

  useEffect(() => {
    if (uploadedFiles) {
      onUpload(uploadedFiles);
    }
  }, [onUpload, uploadedFiles]);

  const handleFileChange = (evt) => {
    setUploadedFiles([...evt.target.files]);
    // eslint-disable-next-line no-param-reassign
    evt.target.value = null;
  };

  return (
    <Container className={classes.container}>
      <Container>
        <Typography variant="h6" className={classes.title}>
          Your subscription is now ready!
        </Typography>
        <Typography variant="h6" className={classes.title}>
          Do you want to upload your first Imaging Study?
        </Typography>
      </Container>
      <Container className={classes.container1}>
        <Typography variant="subtitle1" className={classes.subtitle}>
          Your personalized medical record is now ready to be populated. If you have your Imaging Studies at hand you can now proceed to upload your files. You can also return to
          your dashboard to upload files at a later stage.
        </Typography>
      </Container>
      <Container className={classes.container2}>
        <input onChange={handleFileChange} multiple directory="" webkitdirectory="" moxdirectory="" hidden id="raised-button-study" type="file" />
        <label htmlFor="raised-button-study">
          <Button variant="contained" color="primary" component="span">
            Upload new file
          </Button>
        </label>
      </Container>
      <Container className={classes.container3}>
        <Typography className={classes.subtitle2}>
          Considering getting a video report for one of your Imaging Studies?{' '}
          <Link component={RouterLink} to="/personalized-video" className={classes.link}>
            Request now
          </Link>
        </Typography>
      </Container>
    </Container>
  );
};
